<template>
  <div class="news">
    <banner title="新闻资讯" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div class="content-nav-btn" :class="{ 'content-nav-active': newstype == 1 }" @click="newstype = 1">
            <span>公司新闻</span>
          </div>
          <div class="content-nav-btn" :class="{ 'content-nav-active': newstype == 2 }" @click="newstype = 2">
            <span>行业动态</span>
          </div>
        </div>

        <div class="content-nav-item">
          <div class="item-list" v-for="(item, index) in newsList" :key="index">
            <div class="item-img" v-lazy:background-image="item.Img"></div>

            <p class="item-list-title">{{ item.Title }}</p>
            <p class="item-list-content">{{ item.Content }}</p>
            <div class="item-list-more">
              <router-link class="text-decoration" :to="{ name: 'newsdetails', params: { id: item.id } }">
                <img src="../assets/img/sanjiao.png" />
                <span>more</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 1
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      if (this.newstype == 1) {
        this.newsList = [
          {
            id: 0,
            Img: `http://www.sdtimo.com/imgs/3-2.png`,
            Title: `阔步新征程，同心谱华章`,
            Content: `一个称赞、一个大拇指、一封表扬信......这些看似简单的举动，是客户对天茂信息数据服务团队能力的肯定。`,
          },
          {
            id: 1,
            Img: `http://www.sdtimo.com/imgs/3-2.png`,
            Title: `热烈祝贺天茂信息成为山东省软件行业协会会员单位`,
            Content: `近年来，天茂信息基于RFID射频技术不断加强软件产品自主研发和创新力度，提高数据信息化服务效益，在互联网、物联网软件应用领域做出了积极探索。
            此次，山东天茂信息有限公司顺利通过山东省软件行业协会会员审核，是全省软件行业对我公司软件产品质量的高度肯定与鼓励，也是公司发展史上的又一个重要里程碑，
            我们将以此为契机，加大产品创新力度，深化数据产品与数据服务无缝衔接，争取在软件产品质量管理和体系建设方面再上一个新台阶！ `,
          },
          {
            id: 2,
            Img: `http://www.sdtimo.com/imgs/3-1.jpg`,
            Title: `天茂信息成功入库“国家科技型中小企业”`,
            Content: `国家科技型中小企业是指科技管理体系健全自主创新能力较强产品技术含量较高，具有较强的竞争力较好的市场前景，
            企业依托一定数量的科技人员从事科学技术研究开发活动，取得自主知识产权并将其转化为高新技术产品或服务，以创新为使命和生存手段从而实现可持续发展的中小企业 `,
          },
        ]
      } else {
        this.newsList = [
          {
            id: 3,
            Img: `http://www.sdtimo.com/imgs/4-1.jpg`,
            Title: `行政事业性国有资产管理条例`,
            Content: `《行政事业性国有资产管理条例》已经2020年12月30日国务院第120次常务会议通过，现予公布，自2021年4月1日起施行。 `,
          },
          {
            id: 4,
            Img: `http://www.sdtimo.com/imgs/4-2.jpg`,
            Title: `行政事业单位固定资产管理主要风险点及对策`,
            Content: `无论何种单位，固定资产都是其运营与发展的有力保障。对行政事业单位而言，固定资产的所有权归属于国家，固定资产管理的效果，
            直接关系着国有资产的保值增值。其重要性不言而喻。我国行政事业单位之所以要对固定资产进行管理和风险防范，其目的是为了实现国有资产的保值与增值。
            在该前提目标下，再对固定资产进行资源配置和结构调整，从而提高资产利用率。有效的固定资产管理和风险防范，有助于我国行政事业单位内部管理水平的提升。
            然而当前，纵观我国行政事业单位固定资产管理和风险防范的现状，不难发现，在该类单位的固定资产管理中尚存在诸多问题和漏洞，严重影响和制约着行政事业单位的运行与发展，亟待改进。 `,
          },
          {
            id: 5,
            Img: `http://www.sdtimo.com/imgs/4-3.jpg`,
            Title: `聚焦两会|固定资产管理的重要性`,
            Content: `2021年，财政部深入推进国有资产管理改革并获得一系列突破性成果，
            包括出台行政事业性国有资产管理条例以下简称条例完成2020年度国有资产管理情况综合报告并向全国人大常委会报告，
            在推进国资国企改革强化国有资本经营预算和新增资产配置预算管理等领域都取得许多新成效 `,
          },
          {
            id: 6,
            Img: `http://www.sdtimo.com/imgs/4-4.png`,
            Title: `财政部：加强行政事业单位固定资产管理`,
            Content: `要加强固定资产使用管理，行政单位固定资产主要保障机关正常运转，事业单位固定资产主要支撑事业发展，
            行政单位和事业单位原则上不得互相占用固定资产，确保固定资产功能与单位职能相匹配 `,
          },
          {
            id: 7,
            Img: `http://www.sdtimo.com/imgs/1-3.jpg`,
            Title: `财政部：行政事业单位要有效盘活固定资产`,
            Content: `近日，财政部印发关于加强行政事业单位固定资产管理的通知以下简称通知指出，各部门各单位要有效盘活并高效使用固定资产，
            从落实管理责任加强基础管理规范管理行为完善追责机制4方面14条有关事项着手，有针对性地解决固定资产管理中存在的突出问题，进一步加强行政事业单位固定资产管理 `,
          },
          {
            id: 8,
            Img: `http://www.sdtimo.com/imgs/4-5.png`,
            Title: `中央党政机关和事业单位所属企业国有资本产权登记管理暂行办法`,
            Content: `财政部印发《中央党政机关和事业单位所属企业国有资本产权登记管理暂行办法》 `,
          },
        ]
      }
      // this.$http
      //   .get(`News?type=${this.newstype}&num=6`)
      //   .then(response => {
      //     //console.log(response);
      //     this.newsList = response.data;
      this.loading = false;
      //     //window.console.log(this.newsList);
      //   })
      //   .catch(function(error) {
      //     window.console.log(error);
      //   });
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.news {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid red;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }

          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }

            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }

  .text-decoration {
    text-decoration: none;
  }
}
</style>